export function ItemsSorter({addItems, removeItems}) {
    const hasItemsToAdd = !!addItems;
    const hasItemsToRemove = !!removeItems;

    return <div className="btn-group-vertical">
        <button type="button" className="btn btn-primary" onClick={() => moveSelected(addItems)} disabled={!hasItemsToAdd}>
            <i className="fa fa-arrow-right"/>
        </button>
        {(() => {
            if (hasItemsToAdd) {
                return <button type="button" className="btn btn-primary" onClick={() => moveAll(addItems)}>
                    <i className="fa fa-angles-right"/>
                </button>;
            } else if (hasItemsToRemove) {
                return <button type="button" className="btn btn-primary" onClick={() => moveAll(removeItems)}>
                    <i className="fa fa-angles-left"/>
                </button>;
            } else {
                return <button type="button" className="btn btn-primary" disabled={true}>
                    <i className="fa fa-angles-right"/>
                </button>;
            }
        })()}
        <button type="button" className="btn btn-primary" onClick={() => moveSelected(removeItems)} disabled={!hasItemsToRemove}>
            <i className="fa fa-arrow-left"/>
        </button>
    </div>;
}

function moveSelected(moveFn) {
    if (moveFn) {
        const movedCollection = moveFn((type, item, index, isSelected) => isSelected);
        if (movedCollection.items.length === 0) {
            // Move the first item for convenience, when nothing is selected
            moveFn((type, item, index) => index === 0);
        }
    }
}

function moveAll(moveFn) {
    if (moveFn) {
        moveFn(() => true);
    }
}
